import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntypedFormGroup } from '@angular/forms';
import { KEY_DATES } from 'src/app/product-capture/model/consts/key-dates.const';
import { OFFSET } from 'src/app/product-capture/model/consts/offset.const';
import { ROLL_CONVENTION } from 'src/app/product-capture/model/consts/roll-convention.const';
import { SETTLEMENT_TRADING } from 'src/app/product-capture/model/consts/settlement-trading.const';
import { KeyDates, RowKey, RowName, RowTitle } from '../key-dates-type.const';

@Component({
  selector: 'app-date-row',
  templateUrl: './date-row.component.html',
  styleUrls: ['./date-row.component.scss'],
})
export class DateRowComponent implements OnInit {
  @Input() parentForm: UntypedFormGroup;
  @Input() groupName: RowName;
  @Input() groupTitle: RowTitle;
  @Input() key: RowKey;
  @Input() dropdownParent: string;
  @Input() hideTradingDropdowns: boolean;

  keyDates = KEY_DATES;
  offsetItems = OFFSET;
  calendarItems = SETTLEMENT_TRADING;
  rollConventionItems = ROLL_CONVENTION;
  fromItems;
  readonlyDropdowns: boolean;
  readonlyDate: boolean;
  destroyRef = inject(DestroyRef);

  constructor() {}

  ngOnInit(): void {
    this.readonlyDropdowns = false;
    this.readonlyDate = true;
    this.fromItems = this.filterFromItems(this.keyDates, this.groupTitle);

    const row = this.parentForm.controls[this.groupName] as UntypedFormGroup;
    const override = row.controls[this.key + 'Override'];

    if (override.value === true) {
      this.readonlyDropdowns = true;
      this.readonlyDate = false;
    }

    override.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => {
        this.readonlyDropdowns = value;
        this.readonlyDate = !value;

        if (value) {
          Object.keys(row.controls).forEach((key) => {
            if (key === `${this.key}Override`) {
              return;
            }

            row.controls[key].patchValue(null, { emitEvent: false });
          });
        } else {
          row.controls[`${this.key}Date`].setValue(null);
        }
      });

    this.calendarItems = this.hideTradingDropdowns
      ? SETTLEMENT_TRADING.filter((item) => item.id !== 'TRADING')
      : SETTLEMENT_TRADING;
  }

  filterFromItems(keyDates: KeyDates, rowTitle: RowTitle) {
    return keyDates.filter((obj) => obj.displayValue !== rowTitle);
  }

  onFocus() {
    const formGroupValue = this.parentForm.controls[this.groupName].value;

    // If all fields are empty, set override to true because the user
    // has clicked into the date to enter an absolute date
    if (
      Object.keys(formGroupValue)
        .filter((key) => key !== this.key + 'Date')
        .every((key) => !formGroupValue[key])
    ) {
      this.parentForm.controls[this.groupName].patchValue(
        { [this.key + 'Override']: true },
        { emitEvent: true }
      );
    }
  }

  toggleCheckbox(key: string, groupName: string): void {
    const checkboxControl = this.parentForm.get(groupName).get(`${key}Override`);
    checkboxControl.setValue(!checkboxControl.value);
  }
}
